import { AppShell } from '@mantine/core'
import { PageProps } from 'gatsby'
import { FC } from 'react'
import * as classes from './blankLayout.module.css'

const BlankLayout: FC<PageProps> = ({ children }) => {
  return (
    <AppShell className={classes.container}>
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  )
}

export default BlankLayout
